var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCustomLayout)?_c(_vm.customLayout,{tag:"component",staticClass:"custom-wuji-layout"}):_c('DefaultLayout',_vm._g(_vm._b({},'DefaultLayout',_vm.$props,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }